export default "__VITE_ASSET__DHJsyPmG__"